module.exports = (obj, predicate = v => v == null) => obj && Object.fromEntries(Object.entries(obj).filter(([, v]) => !predicate(v)));
